export const state = {
  AWSKey: 'AKIAIHR52QVCFZWNVJXQ',
  user: {
    authenticated: false,
    avatar_url: '',
    name: '',
    email: '',
    email_confirmed: false,
    has_usable_password: false,
    content_area: '',
    position: '',
    school: '',
    grade: '',
    colleagues: [],
    groups: [],
  },

  socialAccountConnections: {
    'google': null,
    'microsoft': null,
    'clever': null,
  },

  // List of strings of feature flags
  flags: [],

  loadingNotificationsData: false,
  notifications: [],
  mostRecentNotification: 0,

  notification: {
    show: false,
    message: '',
    level: '',
    sticky: false,
  },

  socialLoginErrors: {
    email: [],
    nonFieldErrors: [],
  },

  loadingResendEmailConfirmation: false,

  rubricElements: [],

  loginErrorMessage: '',

  exercises: [],
  loadingExercises: false,
  savingExercise: false,
  savingResponse: false,
  updatingResponse: false,

  addingRubricEementtoComment: false,
  addingReply: false,

  errorAddingFile: false,
  showAddVideoModal: false,
  showAddFileModal: false,
  showAddToVideoModal: false,
  showShareModal: false,
  showAddUserModal: false,

  loadingTeamData: false,
  teams: [],
  removingUserFromTeam: false,
  addingUserToTeam: false,

  loadingVideos: false,
  videos: {},
  videosSharedWithMe: [],

  libraries: [],
  activeLibrary: null,
  activeLibraryID: null,
  loadingLibraryData: false,

  sendingToProcessing: false,
  clippingVideo: false,

  displayAddComment: false,
  addingComment: false,

  loadingResources: false,
  resources: [],
  addingFile: false,

  loadingGroup: false,
  group: {
    users: [],
  },

  userInput: '',

  folders: [],
  sharedFolders: [],
  loadingFolders: false,

  pendingMembers: [],
  loadingMembers: false,

  invites: [],

  setLoadingTagsData: false,
  tags: [],

  artformcomments: [],
}

// we want a copy, not a reference
export const defaultState = { ...state }

export default state



// WEBPACK FOOTER //
// ./src/state.js